import { addMutator } from '@poa/state';
import {
  logIn,
  logInFailed,
  logInSuccess,
  restoreSession,
  updatePermissions
} from './auth.actions';
import { ACCESS_LEVEL, GRANTED_HOSTS, SUBDOMAINS } from './auth.constants';

function saveToken({ accessLevel, accessHosts }, { store }) {
  store.auth.meta.isLoading = false;
  store.auth.meta.hasError = false;
  store.auth.accessLevel = accessLevel;
  store.auth.accessHosts = accessHosts;
}

addMutator(logIn, (_, { store }) => {
  store.auth.meta.isLoading = true;
  store.auth.meta.hasError = false;
});

addMutator(logInSuccess, saveToken);
addMutator(restoreSession, saveToken);

addMutator(logInFailed, (_, { store }) => {
  store.auth.meta.isLoading = false;
  store.auth.meta.hasError = true;
});

addMutator(updatePermissions, ({ hostname, accessLevel, accessHosts }, { store }) => {
  const hostnameParts = hostname.split('.');

  switch (accessLevel) {
    case ACCESS_LEVEL.account_manager:
      store.auth.canShow.accounts = true;
      store.auth.canShow.staff = true;
      store.auth.canShow.wallet = true;
      store.auth.canShow.chats = true;
      break;
    case ACCESS_LEVEL.manager:
      store.auth.canShow.reports = true;
      store.auth.canShow.accounts = true;
      store.auth.canShow.plugin = true;
      store.auth.canShow.staff = true;
      store.auth.canShow.credentials = true;
      store.auth.canShow.letters = true;
      store.auth.canShow.statistics = true;
      store.auth.canShow.clientsList = true;
      store.auth.canShow.calendar = true;
      store.auth.canShow.transfers = true;
      store.auth.canShow.archives = true;
      store.auth.canShow.contactInfo = true;
      store.auth.canShow.gifts = true;
      store.auth.canShow.payers = true;
      store.auth.canShow.calendar2 = true;
      store.auth.canShow.dashboard = true;
      store.auth.canShow.general = true;
      store.auth.canShow.ai_reports = true;
      store.auth.canShow.chats = true;
      break;
    case ACCESS_LEVEL.operator:
      store.auth.canShow.reports = true;
      store.auth.canShow.accounts = true;
      store.auth.canShow.letters = true;
      store.auth.canShow.statistics = true;
      store.auth.canShow.plugin = true;
      store.auth.canShow.calendar = true;
      store.auth.canShow.clientsList = true;
      store.auth.canShow.contactInfo = true;
      store.auth.canShow.gifts = true;
      store.auth.canShow.payers = true;
      store.auth.canShow.calendar2 = true;
      store.auth.canShow.general = true;
      break;
    case ACCESS_LEVEL.scout:
      store.auth.canShow.reports = true;
      store.auth.canShow.accounts = true;
      break;
    case ACCESS_LEVEL.teamlead:
      store.auth.canShow.reports = true;
      store.auth.canShow.accounts = true;
      store.auth.canShow.plugin = true;
      store.auth.canShow.calendar = true;
      store.auth.canShow.staff = true;
      store.auth.canShow.letters = true;
      store.auth.canShow.statistics = true;
      store.auth.canShow.clientsList = true;
      store.auth.canShow.transfers = true;
      store.auth.canShow.archives = true;
      store.auth.canShow.contactInfo = true;
      store.auth.canShow.gifts = true;
      store.auth.canShow.payers = true;
      store.auth.canShow.calendar2 = true;
      store.auth.canShow.dashboard = true;
      store.auth.canShow.general = true;
      store.auth.canShow.ai_reports = true;
      store.auth.canShow.chats = true;
      break;
    case ACCESS_LEVEL.agency:
      store.auth.canShow.accounts = true;
      store.auth.canShow.reports = true;
      store.auth.canShow.plugin = true;
      store.auth.canShow.calendar = true;
      store.auth.canShow.calendar2 = true;
      store.auth.canShow.daemons = true;
      store.auth.canShow.staff = true;
      store.auth.canShow.credentials = true;
      store.auth.canShow.letters = true;
      store.auth.canShow.statistics = true;
      store.auth.canShow.transfers = true;
      store.auth.canShow.archives = true;
      store.auth.canShow.contactInfo = true;
      store.auth.canShow.gifts = true;
      store.auth.canShow.payers = true;
      store.auth.canShow.home = true;
      store.auth.canShow.dashboard = true;
      store.auth.canShow.general = true;
      store.auth.canShow.wallet = true;
      store.auth.canShow.chats = true;
      store.auth.canShow.ai_reports = true;
      break;
    case ACCESS_LEVEL.observer:
        store.auth.canShow.accounts = true;
        break;
    case ACCESS_LEVEL.visor:
        store.auth.canShow.accounts = true;
        break;
    default:
      break;
  }

  const [subdomain] = hostnameParts;

  switch (subdomain) {
    case SUBDOMAINS.dm:
      store.auth.currentHost = GRANTED_HOSTS.dm;
      break;
    case SUBDOMAINS.pd:
      store.auth.currentHost = GRANTED_HOSTS.pd;
      break;
    case SUBDOMAINS.of:
      store.auth.currentHost = GRANTED_HOSTS.of;
      break;
    default:
      store.auth.currentHost = GRANTED_HOSTS.nc;
  }

  switch (store.auth.currentHost) {
    case GRANTED_HOSTS.dm:
      store.auth.canShow.clientsList = false;
      store.auth.canShow.letters = false;
      break;
    case GRANTED_HOSTS.of:
      store.auth.canShow.clientsList = false;
      store.auth.canShow.letters = false;
      break;
    case GRANTED_HOSTS.nc:
      store.auth.canShow.payers = false;
      store.auth.canShow.plugin = false;
      store.auth.canShow.letters = false;
      break;
    default:
      break;
  }

  if (accessHosts.includes(store.auth.currentHost)) {
    store.auth.canAccessCurrentHost = true;
  }
});
